<template>
  <b-form class="form-register" @submit="onSubmit" @reset="onReset">
    <b-form-group class="text-description">
      Please sign up to create your CN account and begin building your lifelong
      ePortfolio.
    </b-form-group>
    <b-row class="last-first-name">
      <b-col>
        <b-form-group
          class="group-item"
          id="group-first-name"
          label="First Name"
          label-for="group-first-name"
        >
          <b-form-input
            id="input-first-name"
            v-model="form.first_name"
            type="text"
            required
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          class="group-item"
          id="group-last-name"
          label="Last Name"
          label-for="group-last-name"
        >
          <b-form-input
            id="input-last-name"
            v-model="form.last_name"
            type="text"
            required
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group
      style="display:none"
      class="group-item"
      id="group-first-name-2"
      label="First Name"
      label-for="group-first-name"
    >
      <b-form-input
        id="input-first-name"
        v-model="form.first_name"
        type="text"
        required
      >
      </b-form-input>
    </b-form-group>

    <b-form-group
      style="display:none"
      class="group-item"
      id="group-last-name-2"
      label="Last Name"
      label-for="group-last-name"
    >
      <b-form-input
        id="input-last-name"
        v-model="form.last_name"
        type="text"
        required
      >
      </b-form-input>
    </b-form-group>

    <b-form-group
      class="group-item"
      id="group-email"
      label="Email"
      label-for="group-email"
      :description="displaySignupEmailHint"
    >
      <b-form-input
        id="input-email"
        v-model="form.email"
        type="email"
        required
      ></b-form-input>
    </b-form-group>

    <b-form-group
      class="group-item"
      v-if="isTypeCode"
      id="group-code"
      label="Institution Code"
      label-for="group-code"
    >
      <b-form-input
        id="input-code"
        v-model="form.signup_site_brand_pin_code"
        type="password"
        required
      ></b-form-input>
    </b-form-group>
    <b-form-group
      v-if="enabledUserLabelSelfSelection"
      class="group-item"
      label="Affiliation"
      label-for="labels"
    >
      <b-form-select
        id="labels"
        v-model="form.labels[0]"
        :options="userLabels"
        placeholder="Please Select One"
        required
      ></b-form-select>
    </b-form-group>

    <div class="new-postion">
      <b-form-group class="text-left login-group">
        <span class="hint-login mr-4 new-design-text"
          >Already have an account?</span
        >
        <router-link class="btn-login btn-link-lg" :to="'login'"
          >Log in</router-link
        >
      </b-form-group>
      <b-form-group>
        <b-button
          class="btn-submit btn-success new-design-button"
          type="submit"
          variant="primary"
          >Next</b-button
        >
      </b-form-group>
    </div>

    <div class="search-eportfolios-link">
      <router-link :to="'index'">
        <span> Search ePortfolios at {{ title }}</span>
      </router-link>
    </div>

    <b-modal ref="my-modal" title="Message">
      <p v-text="message"></p>
    </b-modal>
  </b-form>
</template>

<script>
import { SET_USER } from "@/store/mutation-types";
import md5 from "md5";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

export default {
  name: "form-register",
  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        email: "",
        signup_site_brand_pin_code: "",
        labels: [],
      },
      message: "",
    };
  },
  computed: {
    password: {
      get: function() {
        return md5(this.form.email).slice(0, 10);
      },
    },
    displaySignupEmailHint() {
      const hint = this.signupEmailHint;
      if (!hint) {
        return null;
      }
      let emails = hint.split(/[,\s\n\r]+/);
      if (!emails.length) {
        return null;
      }

      return `(must be ${emails.map((i) => `@${i}`).join(", ")})`;
    },
    ...mapGetters("siteBrand", [
      "isTypeCode",
      "isTypeEmail",
      "isTypeNoOne",
      "isTypeAnyOne",
      "enabledUserLabelSelfSelection",
      "userLabels",
    ]),
    ...mapGetters("siteBrand", {
      signupEmailHint: "getSignupEmailHint",
    }),
    ...mapState("siteBrand", [
      "title",
      "heading",
      "signup_setting_hint",
      "brand",
    ]),
  },
  methods: {
    ...mapActions("siteBrand", ["checkUserSignup"]),
    ...mapMutations("user", [SET_USER]),
    resetForm() {
      this.form = {
        first_name: "",
        last_name: "",
        email: "",
        signup_site_brand_pin_code: "",
        labels: [],
      };
    },
    onSubmit(evt) {
      evt.preventDefault();

      this.checkUserSignup({
        email: this.form.email,
        pinCode: this.form.signup_site_brand_pin_code,
      })
        .then((data) => {
          if (!data?.result && data?.errors?.length) {
            this.message = data.errors.join(",");
            this.$refs["my-modal"].show();
            return;
          }

          this[SET_USER](Object.assign(this.form));
          this.$emit("submit");
        })
        .catch(() => {});
    },
    onReset(evt) {
      evt.preventDefault();
    },
  },
};
</script>

<style scoped lang="scss">
.form-register {
  // position: relative;
  min-height: 60vh;
}

.new-design-text {
  font-size: rem(16);
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
}

.new-design-button {
  width: rem(140);
  height: rem(40);
  background: #3574d9;
  box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

#group-last-name,
#group-first-name {
  width: 100%;
  margin-bottom: 0;
}

.group-item {
  color: #1a374d;
  margin-top: rem(24);

  input,
  select {
    // height: rem(48);
    // background: #ffffff;
    border: rem(1) solid #babdcc;
    border-radius: rem(8);
  }
}

@media all and (max-width: 768px) {
  .form-register {
    height: auto;
  }

  .last-first-name {
    display: none;
  }

  #group-first-name-2,
  #group-last-name-2 {
    display: block !important;
  }

  .group-item {
    margin-top: rem(20);

    input {
      height: rem(46);
    }
  }

  .univ-descript {
    margin-top: rem(7);

    div {
      font-size: rem(12);
    }
  }

  .new-postion {
    position: initial;
    margin-top: rem(20);
  }

  .new-design-text {
    font-size: rem(14);
  }

  .new-design-login {
    font-size: rem(14);

    margin-left: rem(-15);
  }

  .login-group {
    margin-top: 5vh;
  }
}
</style>
